import { render, staticRenderFns } from "./DataFetcher.vue?vue&type=template&id=452e8cc9&scoped=true&"
import script from "./DataFetcher.vue?vue&type=script&lang=ts&"
export * from "./DataFetcher.vue?vue&type=script&lang=ts&"
import style0 from "./DataFetcher.vue?vue&type=style&index=0&id=452e8cc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e8cc9",
  null
  
)

export default component.exports